module.exports = __webpack_public_path__ + "static/media/dsr_ico_bootcamp.775171ff.svg";